export function getRandomArrayItem(array) {
    return array[Math.floor(Math.random() * array.length)];
}
//# sourceMappingURL=testHelpers.js.map